export const normalizeGames = (games) => {
  const values = Array.isArray(games)
    ? games
    : typeof games === "string"
      ? games.split(/[,|/]/)
      : []

  return values
    .map((game) => String(game).trim().toLowerCase())
    .filter(Boolean)
}
